import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["details"];

  connect() {
    console.log("Competency Selection controller connected");
  }

  toggleDetails(event) {
    const checkbox = event.target;
    const detailsDiv = this.detailsTarget;

    if (checkbox.checked) {
      detailsDiv.classList.remove("hidden");
      // Make rating field required
      const ratingSelect = detailsDiv.querySelector('select[name*="[rating_value]"]');
      if (ratingSelect) {
        ratingSelect.setAttribute("required", "required");
      }
    } else {
      detailsDiv.classList.add("hidden");
      // Remove required attribute
      const ratingSelect = detailsDiv.querySelector('select[name*="[rating_value]"]');
      if (ratingSelect) {
        ratingSelect.removeAttribute("required");
      }
    }
  }
}

